import { useNotification } from '@/hooks/use-notification';
import { usePriceEventQueueStatus } from '@/pages/queries';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const PRICE_EVENT_QUEUE_NOTIFICATION_ID = 'price-event-queue-status';

export const PriceEventQueueMonitor = () => {
  const { isError, isSuccess } = usePriceEventQueueStatus();
  const { pathname } = useLocation();
  const showNotification = useNotification();
  const [hasPriceUpdateError, setHasPriceUpdateError] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Show the error toast again when the page path changes.
  useEffect(() => {
    if (hasPriceUpdateError) {
      showNotification({
        type: 'error',
        id: PRICE_EVENT_QUEUE_NOTIFICATION_ID,
        duration: 0,
        title: 'Prices are not updated',
        description:
          'Price update in progress. Some prices may be temporarily unavailable.',
      });
    }
  }, [hasPriceUpdateError, pathname, showNotification]);

  useEffect(() => {
    if (isError) {
      setHasPriceUpdateError(true);
    } else if (isSuccess && hasPriceUpdateError) {
      setHasPriceUpdateError(false);
      showNotification({
        id: PRICE_EVENT_QUEUE_NOTIFICATION_ID,
        type: 'success',
        title: 'Price update complete',
        description: 'Price update finished — all prices are now available.',
      });
    }
  }, [isError, isSuccess, hasPriceUpdateError, showNotification]);

  return <Outlet />;
};
